module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy Holder\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nancy Holder has published more than 200 short stories and seventy-eight books, including the "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling Wicked series. She lives in San Diego with her daughter, Belle, and far too many animals. Visit her at Nancy Holder.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ma9Y4Y/tc-custom/9781442430174.jpg?1730520792357",
      "alt": "This image is the cover for the book Rose Bride, Once Upon a Time"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rose Bride, Once Upon a Time\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("\"Once upon a Time\" Is Timeless")]), _c('br'), _c('br'), _vm._v(" When Rose's mother dies, her only comfort is the exquisite rose garden her mother left behind. The purple blossoms serve as an assurance of her mother's love. But Rose is dealt a second blow when her father dies and his greedy widow, Ombrine, and her daughter, Desirée, move in and take over the manor in true Cinderella fashion. "), _c('br'), _c('br'), _vm._v(" Fate has been cruel to Ombrine and Desirée, too. So despite their harsh ways, Rose has compassion. But these feelings are bitterly tested when, in a rage, Ombrine tears out the garden. Rose nearly gives up all hope -- until a chance meeting with the king. Happiness might be within her reach, but first she must prevail over Ombrine. And then she must determine if she has the courage to love.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon Pulse\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0